import { getUrlObject } from '../url/getUrlObject';
import { cloudinaryCloudRegExp, cloudinaryProxyRegExp } from './constants';

const hlsDisabled = undefined; /*Envs.cloudinary.hlsDisabled*/

type AssetType = 'video' | 'image';
type GetCloudinaryVideoUrlAutoFormatReturn =
	| {
			hlsSrc: string;
	  }
	| {
			autoFormatVideoSrc: string;
	  }
	| {
			autoFormatImageSrc: string;
	  };

interface CloudinaryOptions {
	cloudName?: string;
	proxyDomain?: string;
}

const getCloudinaryAssetProxyUrl = (
	cloudinaryUrl: string,
	cloudinaryOptions?: CloudinaryOptions,
) => {
	const url = getUrlObject(cloudinaryUrl);
	if (!url) return '';
	if (!cloudinaryOptions) return cloudinaryUrl;
	const { cloudName, proxyDomain } = cloudinaryOptions;
	if (proxyDomain) {
		url.host = proxyDomain;
		if (cloudName && url.pathname.startsWith(`/${cloudName}/`)) {
			url.pathname = url.pathname.slice(cloudName.length + 1);
		}
	}
	return url.toString();
};
export const getCloudinaryAssetUrlAutoFormat = (
	url: string,
	assetType: AssetType,
	hslEnabled?: boolean,
): GetCloudinaryVideoUrlAutoFormatReturn | null => {
	const proxiedUrl = getCloudinaryAssetProxyUrl(url);
	const cloudinaryProxyMatch = proxiedUrl.match(cloudinaryProxyRegExp);
	if (!cloudinaryProxyMatch) return null;
	const [, root, , pathWithoutExtension, ext] = cloudinaryProxyMatch;
	if (assetType === 'image') {
		if (ext === 'svg') {
			return null;
		}
		return {
			autoFormatImageSrc: `${root}/image/upload/f_auto/q_auto/${pathWithoutExtension}`,
		};
	}
	if (typeof hslEnabled === 'boolean' ? hslEnabled : !hlsDisabled) {
		return {
			hlsSrc: `${root}/video/upload/sp_auto/${pathWithoutExtension}.m3u8`,
		};
	}
	return {
		autoFormatVideoSrc: `${root}/video/upload/f_auto:video/q_auto/${pathWithoutExtension}`,
	};
};
export const isCloudinaryAsset = (url: string) => {
	return cloudinaryCloudRegExp.test(url) || cloudinaryProxyRegExp.test(url);
};
